import jump from 'jump.js';

const scrollTo = document.querySelectorAll('.js-scroll-to');

if (scrollTo.length) {
  /**
   * Loop through all scroll-to elements and when click; jump down
   */
  [].forEach.call(scrollTo, (function (element) {
    const position = element.dataset.scrollTo;
    const scrollDuration = element.dataset.scrollDuration ? parseFloat(element.dataset.scrollDuration) : 300;
    const scrollOffset = element.dataset.scrollOffset ? parseFloat(element.dataset.scrollOffset) : 0;
    let scrollTo = position;

    if ( position ) {
      if ( !isNaN(parseFloat(position)) ) {
        scrollTo = parseFloat(position);
      }

      /**
       * Click, jump to position
       */
      element.addEventListener('click', function (e) {
        e.preventDefault();

        jump(scrollTo, {
          duration: scrollDuration,
          offset: scrollOffset,
        });
      });
    }
  }));
}
